
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexTm5G_45p_454bU3hLOxbuQMxsPWSqhcyltFWHsqAg70ZJ9cMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/index.vue?macro=true";
import { default as codiceVIhIJ44t9iV0E6UaZzmyq_5COCpH8vgDWce0IttThTQMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/codice.vue?macro=true";
import { default as privacy8rHO8Uq5vIN9EW4OKgxGx_45ltYAlLfzlPc1b4gMcs0zsMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/privacy.vue?macro=true";
import { default as profilogsQatQXE0j8oiKf2y8wy4gYuYb0rNsNwFX5k3b6m4ZoMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/profilo.vue?macro=true";
import { default as dashboardLKNnCdywEWuJDUQcxDlGXOmHM3NDjG7OCTOQn6ixM8AMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/dashboard.vue?macro=true";
import { default as codice_45otpQqodeRNQmQfu_45jpmzknp7OCecMobXQFlZEnhCo3f7pMMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/codice-otp.vue?macro=true";
import { default as test_firmayOyInHnYEHHUaBe38zYkcUNXrlzMvmjszksJv1QWeokMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/test_firma.vue?macro=true";
import { default as logKudtWBVqvVQGiHNczmFe7PAZGtgUcVhrk2969u4oRzAMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/utilita/log.vue?macro=true";
import { default as impostazioniWftL6JlVXoRjhjMbt6IRm9bsKCxjVPxWD0t0IhB0QbQMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/impostazioni.vue?macro=true";
import { default as indexetJz3y2A_45gZ2we8TNeUWv47_45z6eMO3bR3ykwRJONIi8Meta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/referti/index.vue?macro=true";
import { default as aggiornaVBKTuOQd5ESYQGMA0ot2WzE4RZQcCzQqEBB_7ncKDcUMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/referti/aggiorna.vue?macro=true";
import { default as archivioXrUJ4J9V_45Ovi_45YlNX47dGKg414OTybH2OkmwdCUJuwEMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/utilita/archivio.vue?macro=true";
import { default as dashboard_risorsamN4u1ZGDE27Gz4YBrQhyk4FUyLcWQlKcki8GvHmur2gMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/dashboard_risorsa.vue?macro=true";
import { default as recupera_45passwordO_45ua80O6qEOi2CD1Y_2rQBRtPL_45TWxX7SStw_45u7By_454Meta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/recupera-password.vue?macro=true";
import { default as indexfnL_45o9LowMitQ12a9fn33jWN3aHxUqfeQ9_1pOAFD64Meta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/appuntamenti/index.vue?macro=true";
import { default as consensi_informatiw_rNAH4ec0Sfq1qoSv7ueXFVQfjVroxyMGuV_45fG1G3oMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/consensi_informati.vue?macro=true";
import { default as test_45notificationsbDmNd7IPgTgA0Zq6QOcAEmvFnenoaE9RUvuQSYGXmtMMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/test-notifications.vue?macro=true";
import { default as pazientivwnRFPC2huNe1z_45KGbwqfUkTBW1eTSgLYvv5Te31hukMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/pazienti.vue?macro=true";
import { default as struttureTTegIDUAMgoaUWD1_45AoJzoqtRvOkuyA2cS6ARt0KEBsMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/strutture.vue?macro=true";
import { default as indexmHLLlzV9T7TGnfNzAmBjRNnQSnsa48zf459JdZ30BjYMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/carta_intestata/index.vue?macro=true";
import { default as macro_gruppiVUwxCh6bebL_45_tgTr_45dfHuZxBq8Wz1hABW5MbL3okcQMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/macro_gruppi.vue?macro=true";
import { default as amministratorinYnHp8vKw2r9vhb89BWbJGyAM3Ufj1drJfjuLU4ibmcMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/amministratori.vue?macro=true";
import { default as elenco_personaleG_454XXe0qQM47Xwnk_FNFZCQi9car_s1F_YH7nvJBWg0Meta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/elenco_personale.vue?macro=true";
import { default as tipologie_visiteMir_456OVyu3rHnb0cuvYOomsN3YkyAPjxWUT_45jCaLyaIMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologie_visite.vue?macro=true";
import { default as tipologie_accessoNfF2ejBCbEcmmWM3wLyybcvMyO15YFkGz4bLMcbTA_UMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologie_accesso.vue?macro=true";
import { default as visite_strumentaliPCtA8mVVlepK2a9JJ406EE74rtJfRsfPLeoWFSsVTcwMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/visite_strumentali.vue?macro=true";
import { default as tipologia_operatoriMwUz_45xQnWUBg0vz0Vv6c_MXWaeSlFSnuDQKSlI1N0gEMeta } from "/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologia_operatori.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexTm5G_45p_454bU3hLOxbuQMxsPWSqhcyltFWHsqAg70ZJ9cMeta || {},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/index.vue")
  },
  {
    name: "codice",
    path: "/codice",
    meta: codiceVIhIJ44t9iV0E6UaZzmyq_5COCpH8vgDWce0IttThTQMeta || {},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/codice.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/privacy.vue")
  },
  {
    name: "profilo",
    path: "/profilo",
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/profilo.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardLKNnCdywEWuJDUQcxDlGXOmHM3NDjG7OCTOQn6ixM8AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/dashboard.vue")
  },
  {
    name: "codice-otp",
    path: "/codice-otp",
    meta: codice_45otpQqodeRNQmQfu_45jpmzknp7OCecMobXQFlZEnhCo3f7pMMeta || {},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/codice-otp.vue")
  },
  {
    name: "test_firma",
    path: "/test_firma",
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/test_firma.vue")
  },
  {
    name: "utilita-log",
    path: "/utilita/log",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/utilita/log.vue")
  },
  {
    name: "impostazioni",
    path: "/impostazioni",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/impostazioni.vue")
  },
  {
    name: "referti",
    path: "/referti",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/referti/index.vue")
  },
  {
    name: "referti-aggiorna",
    path: "/referti/aggiorna",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/referti/aggiorna.vue")
  },
  {
    name: "utilita-archivio",
    path: "/utilita/archivio",
    meta: { ...(archivioXrUJ4J9V_45Ovi_45YlNX47dGKg414OTybH2OkmwdCUJuwEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/utilita/archivio.vue")
  },
  {
    name: "dashboard_risorsa",
    path: "/dashboard_risorsa",
    meta: { ...(dashboard_risorsamN4u1ZGDE27Gz4YBrQhyk4FUyLcWQlKcki8GvHmur2gMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/dashboard_risorsa.vue")
  },
  {
    name: "recupera-password",
    path: "/recupera-password",
    meta: recupera_45passwordO_45ua80O6qEOi2CD1Y_2rQBRtPL_45TWxX7SStw_45u7By_454Meta || {},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/recupera-password.vue")
  },
  {
    name: "appuntamenti",
    path: "/appuntamenti",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/appuntamenti/index.vue")
  },
  {
    name: "consensi_informati",
    path: "/consensi_informati",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/consensi_informati.vue")
  },
  {
    name: "test-notifications",
    path: "/test-notifications",
    meta: { ...(test_45notificationsbDmNd7IPgTgA0Zq6QOcAEmvFnenoaE9RUvuQSYGXmtMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/test-notifications.vue")
  },
  {
    name: "anagrafiche-pazienti",
    path: "/anagrafiche/pazienti",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/pazienti.vue")
  },
  {
    name: "anagrafiche-strutture",
    path: "/anagrafiche/strutture",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/strutture.vue")
  },
  {
    name: "carta_intestata",
    path: "/carta_intestata",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/carta_intestata/index.vue")
  },
  {
    name: "anagrafiche-macro_gruppi",
    path: "/anagrafiche/macro_gruppi",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/macro_gruppi.vue")
  },
  {
    name: "anagrafiche-amministratori",
    path: "/anagrafiche/amministratori",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/amministratori.vue")
  },
  {
    name: "anagrafiche-elenco_personale",
    path: "/anagrafiche/elenco_personale",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/elenco_personale.vue")
  },
  {
    name: "anagrafiche-tipologie_visite",
    path: "/anagrafiche/tipologie_visite",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologie_visite.vue")
  },
  {
    name: "anagrafiche-tipologie_accesso",
    path: "/anagrafiche/tipologie_accesso",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologie_accesso.vue")
  },
  {
    name: "anagrafiche-visite_strumentali",
    path: "/anagrafiche/visite_strumentali",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/visite_strumentali.vue")
  },
  {
    name: "anagrafiche-tipologia_operatori",
    path: "/anagrafiche/tipologia_operatori",
    meta: {"middleware":["auth"]},
    component: () => import("/home/mariotrombino/git/progetti/NewMed/app/pages/anagrafiche/tipologia_operatori.vue")
  }
]